export const stepsWebConfig = {
    last_step: 5,
    define_steps: 4,
}

export const stepsCCConfig = {
    last_step: 4,
    define_steps: 3,
}
